module.exports = __webpack_public_path__ + "img/n16.4efee002.png";